import * as React from "react";
import { Separator } from "@/components/ui/separator";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
const complianceStandards = [{
  id: "gdpr",
  name: "Smart Contract Audit",
  description: "Rigorous code verification for all Eagle 47 digital infrastructure ventures.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_gdpr_monochrome.png"
}, {
  id: "soc2",
  name: "Institutional Grade",
  description: "Enterprise-level security protocols managing our global software portfolio.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_soc2_monochrome.png"
}, {
  id: "finra",
  name: "Strategic Compliance",
  description: "Strict alignment with international regulatory and financial standards.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_finra_monochrome.png"
}, {
  id: "iso",
  name: "Cyber Resilience",
  description: "Continuous monitoring and threat detection across all portfolio companies.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_iso27001_monochrome.png"
}, {
  id: "ccpa",
  name: "Privacy Protocol",
  description: "Sovereign data management adhering to elite consumer protection acts.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_ccpa_monochrome.png"
}, {
  id: "hipaa",
  name: "Asset Custody",
  description: "Multi-signature security safeguarding sensitive digital and financial assets.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_hipaa_monochrome.png"
}];
export default function ComplianceSecurityFirst() {
  return <section data-section-id="122757" id="institutional-trust" className="dark bg-background text-foreground py-12 md:py-16">
      <div className="container mx-auto px-4">
        <div className="bg-card/40 border border-border/50 rounded-sm py-8 px-6 md:px-10 shadow-xl backdrop-blur-md">
          <TooltipProvider delayDuration={200}>
            <div className="flex flex-wrap md:flex-nowrap items-center justify-center md:justify-between w-full gap-y-8 md:gap-y-0">
              {complianceStandards.map((standard, i) => <React.Fragment key={standard.id}>
                  <div data-index={i} className="flex items-center justify-center w-1/3 md:w-auto">
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <button type="button" className="cursor-help flex items-center justify-center border-none bg-transparent p-2 m-0 outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-sm transition-transform hover:scale-105" aria-label={`Learn more about ${standard.name}`}>
                          <img src={standard.img} alt={`${standard.name} logo`} className="h-8 md:h-10 w-auto grayscale opacity-40 hover:opacity-100 transition-all duration-500" />
                        </button>
                      </TooltipTrigger>
                      <TooltipContent side="top" className="max-w-[220px] text-center bg-card text-card-foreground border border-primary/20 shadow-2xl rounded-sm">
                        <p className="font-default font-bold text-xs uppercase tracking-widest mb-1 text-primary">
                          {standard.name}
                        </p>
                        <p className="font-sans text-[10px] text-muted-foreground leading-relaxed">
                          {standard.description}
                        </p>
                      </TooltipContent>
                    </Tooltip>
                  </div>
                  {i < complianceStandards.length - 1 && <Separator orientation="vertical" className="hidden md:block h-10 opacity-20 bg-border" />}
                </React.Fragment>)}
            </div>
          </TooltipProvider>
        </div>
      </div>
    </section>;
}